import Navbar from 'react-bootstrap/Navbar'
import styled from 'styled-components'

export const NavbarStretched = styled(Navbar)`
  margin-left: -0.75rem;
  margin-right: -0.75rem;
`
